<template>
  <div class="content-transition" ref="content">
    <!-- Bottone Originale -->
    <!-- <button
      ref="trigger"
      @click="toggleDetails"
      class="content-transition__trigger"
      :class="{
        'is-description-open': isDescriptionOpen,
      }"
    >
      <span v-if="!isDescriptionOpen">{{ $t('cta.projectDetails') }}</span>
      <span v-else>{{ $t('projects.detailsClose') }}</span>
    </button> -->

    <div
      ref="trigger"
      class="content-transition__trigger"
      :class="{
        'is-disabled': isAnimate,
      }"
    >
      <WidgetButtonMorphDetails
        @click="toggleDetails"
        :label="$t('cta.projectDetails')"
      />
    </div>

    <!-- Details -->
    <div class="content-transition-grid__detail" ref="contentDescription">
      <!-- Details grid -->
      <div
        ref="contentDescriptionGrid"
        class="content-transition-grid__detail__col content-transition-grid__detail__grid"
      >
        <!-- Item Row -->
        <div
          class="content-transition-grid__block is-column"
          data-row
          v-for="(row, indexRow) in grid"
          :key="indexRow"
        >
          <div
            class="content-transition-grid__block__inner"
            data-inner
            v-for="(col, indexCol) in row"
            :key="indexCol"
            :class="{ '--small-height': col.smallHeight, '--is-vertical': col.isVertical }"
            
          >
            <div :class="{'--is-text': col.type && col.type === 'text'}" class="content-transition-grid__item" data-clone>
              <template v-if="!debug && showDetailsContent">
                <template v-if="col.type === 'text'">
                 <PagesProjectColumnTextBlock :title="col.title" :text="col.text" class="--in-column-transition" />
              </template>
              <template v-else>
                <template
                  v-if="
                    col.linkVideo !== '' &&
                    col.linkVideoPreview &&
                    col.linkVideoPreview !== ''
                  "
                >
                  <PagesProjectIntro
                    :preview="col.linkVideoPreview"
                    :url="col.linkVideo"
                  />
                </template>
                <template v-else>
                  <WidgetVideo
                    v-if="col.isVideo"
                    :videoUrl="col.linkVideo"
                    :loop="true"
                    :autoplay="true"
                    :muted="true"
                    :preload="'auto'"
                    :playInViewport="true"
                  />
                  <WidgetPicture
                    v-else
                    :image="{ custom: col.image?.responsiveImage }"
                    :lazyLoad="true"
                    :alt="col.image?.responsiveImage?.alt"
                  />
                </template>
              </template>
              </template>
              <template v-else-if="showDetailsContent">
                <img
                  class="placeholder"
                  src="https://placehold.co/2000x1125/000000/png"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- Description -->
      <div
        class="content-transition-grid__detail__col content-transition-grid__detail__text"
        ref="contentDescriptionText"
        data-animate="description-text"
      >
        <div ref="contentDescriptionTextContent">
          <slot name="description"></slot>
        </div>
      </div>
    </div>
    <!-- Grid -->
    <div class="content-transition-grid__content" ref="contentGrid">
      <!-- Item Row -->
      <div
        class="content-transition-grid__block is-row"
        data-row
        v-for="(row, indexRow) in grid"
        :key="indexRow"
      >
        <div
          class="content-transition-grid__block__inner"
          data-inner
          v-for="(col, indexCol) in row"
          :key="indexCol"
          :class="{ '--small-height': col.smallHeight, '--is-vertical': col.isVertical }"
        >
          
          <div :class="{'--is-text': col.type && col.type === 'text'}" class="content-transition-grid__item" data-clone>
            <template v-if="!debug && showGridContent">
              <template v-if="col.type === 'text'">
                <PagesProjectColumnTextBlock :title="col.title" :text="col.text" />
                
              </template>
              <template v-else>
              <template
                v-if="
                  col.linkVideo !== '' &&
                  col.linkVideoPreview &&
                  col.linkVideoPreview !== ''
                "
              >
                <PagesProjectIntro
                  :preview="col.linkVideoPreview"
                  :url="col.linkVideo"
                />
              </template>
              <template v-else>
                <WidgetVideo
                  v-if="col.isVideo"
                  :videoUrl="col.linkVideo"
                  :loop="true"
                  :autoplay="true"
                  :muted="true"
                  :preload="'auto'"
                />
                <WidgetPicture
                  class="is-cover"
                  v-else
                  :image="{ custom: col.image?.responsiveImage }"
                  :lazyLoad="true"
                  :alt="col.image?.responsiveImage?.alt"
                />
              </template>
              </template>
            </template>
            <template v-else-if="showGridContent">
              <img
                class="placeholder"
                src="https://placehold.co/2000x1125/000000/png"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetContentTransitionVucko',
}
</script>

<script setup>
// TODO: Sistemare il bottone trigger al primo load (deve essere già nascosto) e los crolltop alla chiusura dei dettagli

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

const props = defineProps({
  grid: Array,
})

const debug = ref(false)
const showDetails = ref(false)
const isAnimate = ref(false)
const isDescriptionOpen = ref(false)
const showDetailsContent = ref(false)
const showGridContent = ref(true)

const trigger = ref(null)
const content = ref(null)
const contentGrid = ref(null)
const contentDescription = ref(null)
const contentDescriptionGrid = ref(null)
const contentDescriptionText = ref(null)
const contentDescriptionTextContent = ref(null)

const tl = ref(null)
const duration = 0.8
const ease = 'power2.inOut'

onMounted(() => {
  toggleButtonVisibility()
})

const toggleButtonVisibility = () => {
  gsap.set(trigger.value, { yPercent: 160 })

  ScrollTrigger.create({
    trigger: content.value,
    start: 'top bottom',
    end: 'bottom bottom',
    onEnter: () => toggleTriggerVisibility(0),
    onLeave: () => toggleTriggerVisibility(160),
    onEnterBack: () => toggleTriggerVisibility(0),
    onLeaveBack: () => toggleTriggerVisibility(160),
  })
}

const toggleTriggerVisibility = (yPercent) => {
  gsap.to(trigger.value, {
    yPercent,
    duration: duration * 0.5,
    ease,
  })
}

const toggleDetails = () => {
  showDetails.value = !showDetails.value
}

watch(showDetails, async (showDetails) => {
  if (!isAnimate.value) {
    if (showDetails) {
      showDetailsContent.value = true
      isDescriptionOpen.value = true

      gsap.set(contentDescriptionGrid.value, { opacity: 0 })
      cloneAndPositionItems(contentGrid, contentDescriptionGrid)

      await nextTick()
      gsap.set(contentGrid.value, { position: 'absolute' })
      gsap.set(contentDescription.value, {
        position: 'relative',
      })
      tl.value = animateIn()

      if (window.lenis) {
        window.lenis.scrollTo(content.value.offsetTop)
      } else {
        window.scrollTo(content.value.offsetTop)
      }

      await tl.value.play()
      gsap.set(contentGrid.value, { autoAlpha: 0 })
      gsap.set(contentDescriptionGrid.value, {
        opacity: 1,
        position: 'relative',
      })
      ScrollTrigger.refresh()
    } else {
      isDescriptionOpen.value = false
      gsap.set(contentGrid.value, { autoAlpha: 1 })
      cloneAndPositionItems(contentDescriptionGrid, contentGrid, true)
      showDetailsContent.value = false

      await nextTick()
      tl.value = animateOut()

      const scrollTarget =
        content.value.offsetTop +
        contentGrid.value.getBoundingClientRect().height -
        window.innerHeight
      const scrollOffset = window.scrollY - window.innerHeight

      if (scrollOffset > scrollTarget) {
        if (window.lenis) {
          window.lenis.scrollTo(scrollTarget)
        } else {
          window.scrollTo(scrollTarget)
        }
      }

      await tl.value.play()
      gsap.set(contentGrid.value, { position: 'relative' })
      gsap.set(contentDescription.value, {
        position: 'absolute',
      })
      ScrollTrigger.refresh()
    }
  }
})

const animateIn = () => {
  const items = contentGrid.value?.querySelectorAll('[data-clone]')
  const descriptionText = contentDescription.value?.querySelectorAll(
    '[data-animate="description-text"]'
  )

  const tl = gsap.timeline({
    paused: true,
    onStart: () => {
      isAnimate.value = true
    },
    onComplete: async () => {
      await nextTick()

      setupStickyElements()

      gsap.set(items, { clearProps: 'all' })
      tl.kill()
      isAnimate.value = false
    },
  })

  items.forEach((item) => {
    const toState = JSON.parse(item.getAttribute('data-to-state'))
    tl.to(
      item,
      {
        x: toState.x,
        y: toState.y,
        width: toState.width,
        height: toState.height,
        duration,
        ease,
      },
      '<'
    )
  })
  tl.to(descriptionText, { opacity: 1, duration, ease }, 'start-=50%')

  return tl
}

const animateOut = () => {
  const items = contentGrid.value?.querySelectorAll('[data-clone]')
  const descriptionText = contentDescription.value?.querySelectorAll(
    '[data-animate="description-text"]'
  )

  const tl = gsap.timeline({
    paused: true,
    onStart: () => {
      isAnimate.value = true
    },
    onComplete: async () => {
      await nextTick()

      ScrollTrigger.getById('triggerContent')?.kill(true)

      gsap.set([items, descriptionText], { clearProps: 'all' })
      tl.kill()
      isAnimate.value = false
    },
  })

  tl.to(descriptionText, { opacity: 0, duration, ease }, '<')

  items.forEach((item) => {
    tl.to(
      item,
      {
        x: 0,
        y: 0,
        width: 'auto',
        height: 'auto',
        duration,
        ease,
      },
      '<'
    )
  })

  return tl
}

const cloneAndPositionItems = (source, destination, reverse = false) => {
  const sourceRows = source.value?.querySelectorAll('[data-row]')
  const destinationRows = destination.value?.querySelectorAll('[data-row]')

  sourceRows.forEach((sourceRow, index) => {
    const itemsToClone = sourceRow?.querySelectorAll('[data-clone]')

    itemsToClone.forEach((item, itemIndex) => {
      const target =
        destinationRows[index]?.querySelectorAll('[data-inner]')[itemIndex]

      if (reverse) {
        const originalRect = item?.getBoundingClientRect()
        const clone = target?.querySelector('[data-clone]')
        const cloneRect = clone?.getBoundingClientRect()

        gsap.set(clone, {
          x: originalRect.left - cloneRect.left,
          y: originalRect.top - cloneRect.top,
          width: originalRect.width,
          height: originalRect.height,
        })
      } else {
        const clone = target?.querySelector('[data-clone]')
        const cloneRect = clone?.getBoundingClientRect()
        const originalRect = item?.getBoundingClientRect()

        item.setAttribute(
          'data-to-state',
          JSON.stringify({
            x: cloneRect.left - originalRect.left,
            y: cloneRect.top - originalRect.top,
            width: cloneRect.width,
            height: cloneRect.height,
          })
        )
      }
    })
  })
}

const setupStickyElements = () => {
  ScrollTrigger.create({
    id: 'triggerContent',
    trigger: contentDescriptionTextContent.value,
    start: 'bottom bottom',
    end: () => {
      const heightWrap =
        contentDescriptionText.value?.getBoundingClientRect()?.height
      const heightContent =
        contentDescriptionTextContent.value?.getBoundingClientRect()?.height
      const offset = heightWrap - heightContent

      return `bottom+=${offset} bottom`
    },
    pin: contentDescriptionText.value,
  })
}
</script>

<style lang="scss">
@import './style.scss';
</style>
